<div class="close-btn-outer">
  <button aria-label="סגירה" mat-mini-fab color="warn" (click)="close()"><mat-icon>close</mat-icon></button>
</div>
<div mat-dialog-content>
  <div fxLayout="row wrap">
    <div fxFlex="100" fxFlex.gt-sm="50">
      <swiper-container class="h-100" [sale4AllSwiper]="config" init="false" dir="rtl">
        @for (image of product.images; track image) {
          <swiper-slide>
            <img [src]="image.medium" alt="תמונה מוגדלת" loading="lazy"/>
          </swiper-slide>
        }
        <button aria-label="הקודם" mat-icon-button class="swiper-button-prev swipe-arrow"><mat-icon>keyboard_arrow_left</mat-icon></button>
        <button aria-label="הבא" mat-icon-button class="swiper-button-next swipe-arrow"><mat-icon>keyboard_arrow_right</mat-icon></button>
      </swiper-container>
    </div>
    <div fxFlex="100" fxFlex.gt-sm="50" ngClass.gt-sm="px-2 m-0" ngClass.sm="mt-2" ngClass.xs="mt-2">
      <h2>{{product.name}}</h2>
      <div class="py-1 lh">
        <p><span class="text-muted fw-500">{{'sale4you.label.Category' | translate }} </span><span>{{ product?.mainCategory.name }}</span></p>
        <p><span class="text-muted fw-500">{{'sale4you.label.Availibility' | translate }} </span><span>{{ (product?.availibilityCount > 0) ? 'במלאי':'לא זמין'}}</span></p>
      </div>
      <div class="py-1">
        <app-rating [ratingsCount]="product?.ratingsCount" [ratingsValue]="product?.ratingsValue" [direction]="'row'"></app-rating>
      </div>
      <p class="py-1 text-muted lh">{{product.description}}</p>
      <div fxLayoutAlign="end center" class="text-muted">
        <button [mat-dialog-close]="product" mat-icon-button matTooltip="{{'sale4you.label.ViewFullDetails' | translate}}"><mat-icon>arrow_forward</mat-icon></button>
      </div>
      <div class="divider"></div>
      <h2 class="mt-2 new-price">{{'sale4you.label.shekel' | translate }}{{product.clientPrice}}</h2>
      <app-controls [product]="product" [type]="'all'"></app-controls>
    </div>
  </div>
</div>
